export default "__VITE_ASSET__Bbx89a9m__"